// TODO: REPLACE: clientList with companyList when backend done with it and change what should change
import { Link } from 'react-router-dom';
import {
  Content,
  ListCountSelect,
  ListFooter,
  Page,
  Pagination,
  Avatar,
  List,
  LoadingPage,
  DropdownMenu,
  Button,
  QuickMenuIcon,
} from '@trufla-technology/trumarket-react-design-system';
import { useListClients } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { nameInitials } from '../../utils';
import './style.scss';

export const CompaniesList = () => {
  const {
    query,
    data,
    paging,
    handleLimit,
    handleOffset,
    handleSort,
    sortIndex,
    loading,
  } = useListClients({
    paginate: { limit: 5, offset: 0 },
    select: [
      'key',
      'name',
      'type',
      'email',
      'status',
      'phoneNumber',
      'managerName',
      'company',
    ],
    sort: [{ sortBy: 'name', sortOrder: 'asc' }],
  });

  if (!data || !query.paginate || !paging) return <LoadingPage />;

  return (
    <div className="clients-list-page">
      <Content>
        <Page>
          <h1>Companies ({paging?.count})</h1>

          <List
            loading={loading}
            columns={[
              {
                field: 'name',
                label: 'Organization Name',
                sortOrder: sortIndex.name,
                onSort: () => handleSort('name'),

                render: ({ key, name }) => (
                  <Link to={`/clients/${key}`}>
                    <div className="client-list-avatar">
                      <Avatar>{nameInitials(name)}</Avatar>
                    </div>
                    <span>{name}</span>
                  </Link>
                ),
              },
              {
                field: 'status',
                label: 'Contact Person',
                sortOrder: sortIndex?.status,
                onSort: () => handleSort('status'),
              },
              {
                field: 'email',
                label: 'Email',
                sortOrder: sortIndex?.email,
                onSort: () => handleSort('email'),
              },
              {
                field: 'phoneNumber',
                label: 'Phone Number',
                sortOrder: sortIndex?.phoneNumber,
                onSort: () => handleSort('phoneNumber'),
              },
              {
                field: 'managerName',
                label: 'Client Mgr',
                sortOrder: sortIndex?.managerName,
                onSort: () => handleSort('managerName'),
              },
              {
                field: 'company',
                label: 'Company',
                sortOrder: sortIndex?.company,
                onSort: () => handleSort('company'),
              },
              {
                label: '',
                field: 'key',
                render: ({ key }) => (
                  <DropdownMenu
                    items={
                      <>
                        <Button
                          type="link"
                          classes="tru-configure-request"
                          onClick={() => console.log('Configure')}
                        >
                          Configure
                        </Button>
                        <Button
                          classes="tru-disable-request"
                          type="link"
                          onClick={() => console.log('Disable')}
                        >
                          Disable
                        </Button>
                        <Button
                          classes="tru-archive-request"
                          type="link"
                          onClick={() => console.log('Disable')}
                        >
                          Archive
                        </Button>
                      </>
                    }
                    openLeft
                  >
                    <QuickMenuIcon width="6px" />
                  </DropdownMenu>
                ),
              },
            ]}
            data={data}
            footer={
              <ListFooter>
                <ListCountSelect
                  value={query.paginate.limit}
                  options={[5, 10, 15, 20]}
                  onChange={handleLimit}
                />
                <Pagination
                  total={paging.count!}
                  perPage={query.paginate.limit}
                  index={query.paginate.offset! / query.paginate.limit}
                  onChange={(index) =>
                    handleOffset(query.paginate?.limit! * index)
                  }
                />
              </ListFooter>
            }
          />
        </Page>
      </Content>
    </div>
  );
};
